// src/pages/Obrigado.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Obrigado = () => {
  return (
    <div className="relative min-h-screen flex items-center justify-center text-white px-6 py-16">
      {/* Imagem de fundo */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: "url('/imagens/obrigado-bg.jpg')", // Troque pelo seu caminho
        }}
      />
      {/* Overlay escuro */}
      <div className="absolute inset-0 bg-black bg-opacity-70" />

      {/* Conteúdo */}
      <div className="relative max-w-2xl text-center z-10">
        <div className="mb-6">
          <div className="inline-flex items-center gap-2 bg-elion-gold text-elion-navy px-4 py-2 rounded-full text-sm font-semibold shadow-lg">
            🎉 Pagamento aprovado
          </div>
        </div>

        <h1 className="text-4xl md:text-5xl font-extrabold mb-4 leading-tight">
          Tudo pronto para começar!
        </h1>

        <p className="text-lg md:text-xl text-gray-200 mb-6">
          Verifique seu e-mail agora. Você recebeu sua{' '}
          <span className="text-elion-gold font-semibold">
            senha provisória
          </span>{' '}
          e instruções de acesso.
        </p>

        <p className="text-md text-gray-300 mb-8">
          Use o mesmo e-mail da compra e a senha provisória para fazer login.
          Depois, altere sua senha no primeiro acesso.
        </p>

        <Link
          to="/login"
          className="inline-block bg-elion-gold text-elion-navy font-semibold px-8 py-3 rounded-full hover:bg-yellow-400 transition"
        >
          Fazer Login
        </Link>
      </div>
    </div>
  );
};

export default Obrigado;
